import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeOptions, ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { getBrandConfig } from 'src/utils/brandConfig';
import CONFIG from 'src/utils/config';

export const getDefaultTheme = (): ThemeOptions => {
    const { APP_BRAND } = CONFIG;

    const { theme } = getBrandConfig(APP_BRAND);

    return {
        components: {
            MuiCssBaseline: {
                styleOverrides: {
                    body: {
                        overflow: 'hidden',
                    },
                },
            },
            MuiTypography: {
                styleOverrides: {
                    h5: {
                        fontFamily: theme.headingFontFamily,
                        fontWeight: 800,
                    },
                    h6: {
                        fontFamily: theme.headingFontFamily,
                        fontWeight: 600,
                    },
                },
            },
            MuiChip: {
                styleOverrides: {
                    root: {
                        height: 25,
                        lineHeight: '25px',
                        borderRadius: 0,
                        padding: '.5rem',
                        boxSizing: 'content-box',
                    },
                },
            },
            MuiAppBar: {
                styleOverrides: {
                    root: {
                        boxShadow: 'none',
                        borderBottom: `1px solid #e9e9e9`,
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: 0,
                    },
                },
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        borderRadius: 0,
                    },
                },
            },

            MuiListItem: {
                styleOverrides: {
                    root: {
                        '&.Mui-selected': {
                            backgroundColor: `${theme.brandColor} !important`,
                            color: '#FFF !important',
                        },
                        '&.Mui-selected:hover': {
                            backgroundColor: `${theme.brandColor} !important`,
                            color: '#FFF !important',
                        },
                        '&.Mui-selected:focus': {
                            backgroundColor: `${theme.brandColor} !important`,
                            color: '#FFF !important',
                        },
                    },
                },
            },
            MuiListItemIcon: {
                styleOverrides: {
                    root: {
                        width: '.4em',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        paddingLeft: '.7em',
                        marginRight: '30px',
                        minWidth: '0px',
                        color: 'inherit',
                    },
                },
            },
        },
        typography: {
            fontFamily: theme.fontFamily,
        },
        palette: {
            primary: {
                main: '#1c1c1c',
                light: '#eee',
            },
            secondary: {
                main: theme.brandColor,
                contrastText: '#fff',
                light: '#707070',
            },
            background: {
                default: '#FFF',
            },
        },
    };
};

const theme = createTheme(getDefaultTheme());

function withRoot<P>(Component: React.ComponentType<P>) {
    function WithRoot(props?: P) {
        return (
            <ThemeProvider theme={theme}>
                {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
                <CssBaseline />
                {/* @ts-ignore */}
                <Component {...props} />
            </ThemeProvider>
        );
    }

    return WithRoot;
}

export default withRoot;
